<template>
  <v-container fluid style="padding:0">


    <v-sheet id="mainSheet" class="overflow-y-auto" max-height="100vh">
      
      <v-img src="img/imageOne.png" min-height="650" position="top" style="  box-shadow: inset 0 0 0 3000px rgba(27,61,88,.5);
"> 
        <template>

          <v-row justify="center" align="center" style="height:100%;">
            <v-col cols="10" xs="10" sm="10" md="6" lg="6" xl="6" class="center" z-index="100">
              <v-img src="img/logo-wr.png" height="150" contain />
              
              <p
                class="workSansLight text-subtitle-1 text-md-h5 white--text center"
              >Personal Trainers, Fitness Consultants & Nutritionists
              </p>
              
              <p
                class="workSans text-h6 text-md-h4 white--text darken7 "
              >
                Learn how to get in <span style="color:#ED1E21">peak</span> physical shape at any age and stay that
                way.
              </p>

              <p
                class="workSansLight text-subtitle-1 text-md-h5 white--text"
              >
                Don't struggle on your own. Get lasting results you never thought
                possible with expert nutrition coaching and personal training from Haider Baig.
              </p>

              <v-row justify="start" align="center" class="center">
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <v-btn block outlined color="primary" @click="scrollTo('contact')"
                    >Contact me!</v-btn
                  >
                  <!-- <p class="caption white--text center">
                    Limited Spots Available
                  </p> -->
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                  <v-btn 
                    block color="primary" @click="scrollTo('meeting')"
                  >
                    Book a Free Consultation</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </v-img>

      <personal-training/>

      <embed-social/>


      <v-divider />

      <calendar/>

      <v-divider />

      <programs/>

      <v-divider />

      <live-fit/>

      <v-divider />

      <meet-haider/>

      <v-divider />

      <!-- <best-shape/> -->

      <v-divider />

      <v-container style="padding-top:5vh; padding-bottom:5vh" id="workouts">
        <v-row justify="center" align="center" class="center">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <p
              style="line-height:1.25"
              class="text-h4 text-sm-h5 text-md-h5 text-lg-h4 text-xl-h4 black--text font-weight-medium"
            >
             Workout
            </p>


              <p
                style="line-height:1.25"
                class="text-h5 text-sm-h5 text-md-h5 text-lg-h4 text-xl-h4  black--text font-weight-thin"
              >
                Sneak Peak at what working out looks like at LiveFit
              </p>

            <br />
            <br />
            <youtube video-id="pFfIQmPErpI" style="width:80%"></youtube>
          </v-col>
        </v-row>

        <v-row justify="start" align="start">

          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="3"
            lg="3"
            xl="3"
          >
            <youtube video-id="zd9eYQERedA" style="width:80%"></youtube>
          </v-col>


          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="3"
            lg="3"
            xl="3"
          >
            <youtube video-id="pFfIQmPErpI" style="width:80%"></youtube>
          </v-col>

          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="3"
            lg="3"
            xl="3"
          >
            <youtube video-id="koCRMZS11E4" style="width:80%"></youtube>
          </v-col>

          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="3"
            lg="3"
            xl="3"
          >
            <youtube video-id="vC7YifK2MtQ" style="width:80%"></youtube>
          </v-col>

        </v-row>
      </v-container>

      <v-divider />

      <v-container style="padding-top:5vh; padding-bottom:5vh" id="clients">
        <v-row justify="center" align="center" class="center">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <p
              style="line-height:1.25"
              class="text-h4 text-sm-h4 text-md-h4 text-lg-h3 text-xl-h3 black--text font-weight-medium"
            >
              What kind of results do people get?
            </p>

            <p
              style="line-height:1.25"
              class="text-h5 text-sm-h5 text-md-h5 text-lg-h4 text-xl-h4  black--text font-weight-thin"
            >
              People who have used this system have been able to achieve results
              like this.
            </p>
          </v-col>
        </v-row>

        <v-window v-model="client">
          <v-window-item>
            <v-row justify="center" align="center">
              <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-1.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>

              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="3"
                lg="3"
                xl="3"
                offset-md="1"
                offset-lg="1"
                offset-xl="1"
              >
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-2.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>

              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="3"
                lg="3"
                xl="3"
                offset-md="1"
                offset-lg="1"
                offset-xl="1"
              >
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-3.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>
            </v-row>
          </v-window-item>

          <v-window-item>
            <v-row justify="center" align="center">
              <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-4.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>

              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="3"
                lg="3"
                xl="3"
                offset-md="1"
                offset-lg="1"
                offset-xl="1"
              >
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-5.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>

              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="3"
                lg="3"
                xl="3"
                offset-md="1"
                offset-lg="1"
                offset-xl="1"
              >
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-6.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>
            </v-row>
          </v-window-item>

          <v-window-item>
            <v-row justify="center" align="center">
              <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-7.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>

              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="3"
                lg="3"
                xl="3"
                offset-md="1"
                offset-lg="1"
                offset-xl="1"
              >
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-8.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>

              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="3"
                lg="3"
                xl="3"
                offset-md="1"
                offset-lg="1"
                offset-xl="1"
              >
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-9.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>
            </v-row>
          </v-window-item>

          <v-window-item>
            <v-row justify="center" align="center">
              <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-10.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>

              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="3"
                lg="3"
                xl="3"
                offset-md="1"
                offset-lg="1"
                offset-xl="1"
              >
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-11.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>

              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="3"
                lg="3"
                xl="3"
                offset-md="1"
                offset-lg="1"
                offset-xl="1"
              >
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-12.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>
            </v-row>
          </v-window-item>

          <v-window-item>
            <v-row justify="center" align="center">
              <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-13.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>

              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="3"
                lg="3"
                xl="3"
                offset-md="1"
                offset-lg="1"
                offset-xl="1"
              >
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-14.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>

              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="3"
                lg="3"
                xl="3"
                offset-md="1"
                offset-lg="1"
                offset-xl="1"
              >
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-15.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>
            </v-row>
          </v-window-item>

          <v-window-item>
            <v-row justify="center" align="center">
              <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-16.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>

              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="3"
                lg="3"
                xl="3"
                offset-md="1"
                offset-lg="1"
                offset-xl="1"
              >
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-17.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>

              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="3"
                lg="3"
                xl="3"
                offset-md="1"
                offset-lg="1"
                offset-xl="1"
              >
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-18.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>
            </v-row>
          </v-window-item>

          <v-window-item>
            <v-row justify="center" align="center">
              <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-19.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>

              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="3"
                lg="3"
                xl="3"
                offset-md="1"
                offset-lg="1"
                offset-xl="1"
              >
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-20.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>

              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="3"
                lg="3"
                xl="3"
                offset-md="1"
                offset-lg="1"
                offset-xl="1"
              >
                <v-card min-height="200">
                  <v-img
                    src="img/clients/client-21.jpg"
                    lazy-src="img/lazyLoad.png"
                    contain
                  />
                </v-card>
              </v-col>
            </v-row>
          </v-window-item>
        </v-window>

        <v-row justify="center" align="center">
          <v-col cols="1">
            <v-btn icon x-large v-on:click="previousClient">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="1">
            <v-btn icon x-large v-on:click="nextClient">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <v-container fluid style="padding:0; background-color:#fafafa">
        <v-container style="padding-top:5vh; padding-bottom:5vh;">
          <v-row justify="center" align="center" class="center">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <p
                style="line-height:1.25"
                class="text-h4 text-sm-h4 text-md-h4 text-lg-h3 text-xl-h3 black--text font-weight-medium"
              >
                Is personal coaching right for you?
              </p>

              <p
                style="line-height:1.25"
                class="text-h5 text-sm-h5 text-md-h5 text-lg-h4 text-xl-h4  black--text font-weight-thin"
              >
                Personal coaching with Coach Haider Baig is for you if:
              </p>
            </v-col>
          </v-row>

          <v-row justify="center" align="start">
            <v-col
              cols="12"
              xs="12"
              sm="12"
              md="8"
              lg="8"
              xl="8"
              v-for="(item, k) in pCoaching"
              :key="k"
            >
              <v-row justify="start" align="start">
                <v-col cols="2" xs="2" sm="2" md="1" lg="1" xl="1">
                  <v-img :src="item.icon" width="40" />
                </v-col>

                <v-col cols="10" xs="10" sm="10" md="10" lg="10" xl="10">
                  <p
                    style="line-height:1.25"
                    class="left text-h5 text-sm-h5 text-md-h4 text-lg-h6 text-xl-h3 black--text font-weight-medium"
                  >
                    {{ item.heading }}
                  </p>

                  <p
                    style="line-height:1.25"
                    class="text-h6 text-sm-h6 text-md-h5 text-lg-subtitle-1 text-xl-h4 black--text font-weight-regular"
                  >
                    {{ item.body }}
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-container>

      <v-divider />

      <v-container style="padding-top:5vh; padding-bottom:5vh">
        <v-row justify="start" align="start" class="left">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <p
              style="line-height:1.25"
              class="left text-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h3 black--text font-weight-medium"
            >
              Want to get into the best shape of your life? Let me help.
            </p>

            <p
              style="line-height:1.25"
              class="text-h5 text-sm-h5 text-md-h5 text-lg-h4 text-xl-h4  black--text font-weight-thin"
            >
              Lose weight, build strength, and get the accountability you need.
            </p>
          </v-col>
        </v-row>

        <v-row justify="start" align="start" class="left">
          <v-col cols="12" xs="12" sm="12" md="7" lg="7" xl="7">
            <p
              style="line-height:1.75"
              class="text-subtitle-2 text-sm-subtitle-2 text-md-subtitle-1 text-lg-subtitle-1 text-xl-subtitle-1 black--text font-weight-regular"
            >
              Maybe it’s been a while since you’ve been in shape, or felt
              energized throughout your entire day, or felt capable and
              confident enough to do what you truly want.<br /><br />

              If you’re ready to have the body you deserve and get in control of
              your health and fitness once and for all, I’m ready to help.
              You’ve tried doing it alone. Now try with someone who’s ready to
              bring a commitment that’s as serious as your own.<br /><br />

              I’ve dedicated my professional life to helping people transform
              their bodies through nutrition and fitness.<br /><br />

              This is your limited opportunity to work with the best coaching
              team in the industry — to look, feel, and perform better than you
              thought possible.<br /><br />

              I hope to have the opportunity to help you transform your body and
              life forever.<br /><br />

              But the next step is up to you.<br /><br />

              - Haider<br /><br />
            </p>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" offset="1">
            <v-img src="img/circles/circleSeven.svg" width="300" />
          </v-col>
        </v-row>
      </v-container>

      <v-divider />


      <contact/>


      <v-footer dark padless>
        <v-row>
          <v-col cols="12">
            <v-card flat tile class="lighten-1 white--text text-center">
              <v-card-text>
                <v-btn
                  v-for="social in socials"
                  :key="social.icon"
                  class="mx-4 white--text"
                  v-on:click="goToWindow(social.link)"
                  icon
                >
                  <v-icon size="24px">{{ social.icon }}</v-icon>
                </v-btn>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-text class="white--text">
                {{ new Date().getFullYear() }} — <strong>Livefit</strong> Built
                at
                <strong
                  style="cursor:pointer"
                  @click="goToWindow('mailto:dashboard@napcraft')"
                  >Napcraft</strong
                >
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-footer>
      
    </v-sheet>

  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {
    PersonalTraining:()=> import('@/views/main/PersonalTraining.vue'),
    Programs:()=> import('@/views/main/Programs.vue'),
    EmbedSocial:()=> import('@/views/main/EmbedSocial.vue'),


    MeetHaider:()=> import('@/views/main/MeetHaider.vue'),
    Contact:()=> import('@/views/main/Contact.vue'),
    Calendar:()=> import('@/views/main/Calendar.vue'),
    // BestShape:()=> import('@/views/main/BestShape.vue'),
    LiveFit:()=> import('@/views/main/LiveFit.vue'),
  },
  data: () => ({
    model: "caption",
    drawer:false,
    
    client: 0,
    clients: 6,
   
    clientImg: [
      "img/clients/client-1.jpg",
      "img/clients/client-2.jpg",
      "img/clients/client-3.jpg",
      "img/clients/client-4.jpg",
      "img/clients/client-5.jpg",
      "img/clients/client-6.jpg",
      "img/clients/client-7.jpg",
      "img/clients/client-8.jpg",
      "img/clients/client-9.jpg",
      "img/clients/client-10.jpg",
      "img/clients/client-11.jpg",
      "img/clients/client-12.jpg",
      "img/clients/client-13.jpg",
      "img/clients/client-14.jpg",
      "img/clients/client-15.jpg",
      "img/clients/client-16.jpg",
      "img/clients/client-17.jpg",
      "img/clients/client-18.jpg",
      "img/clients/client-19.jpg",
      "img/clients/client-20.jpg",
      "img/clients/client-21.jpg"
    ],
    socials: [
      {
        icon: "mdi-gmail",
        link: "mailto:livefit.3491@gmail.com"
      },
      {
        icon: "mdi-facebook",
        link: "https://www.facebook.com/livefit3491"
      },
      {
        icon: "mdi-instagram",
        link: "https://www.instagram.com/livefit___"
      },
      {
        icon: "mdi-linkedin",
        link: "https://www.linkedin.com/in/haider-baig-032274181"
      }
    ],
    pCoaching: [
      {
        icon: "img/icons/bulletTwo.svg",
        heading:
          "You want to get healthier, fitter, and stronger — and stay that way for the rest of your life",
        body:
          "This program is for people who want to lose weight and body fat, build physical strength and confidence, get results that last, and get off the diet roller-coaster once and for all. I won’t give you a crazy diet or exercise program to follow; instead, I’ll help you build habits that will get you results that last forever."
      },
      {
        icon: "img/icons/bulletTwo.svg",
        heading:
          "You’re tired of “quick fix” programs and are willing to dedicate atleast 3 months to getting in shape the sustainable way",
        body:
          "If you’ve tried something before and “failed” — or just can’t stick with it — know that you’re not alone. And it’s not your fault. After all, self-directed training and nutrition programs fail 98 percent of the time. Not to mention, after many years in the fitness industry, I’ve seen dozens of diet and exercise fads come and go. That’s why I don’t follow fads. Instead, I’ll teach you doable daily actions that are designed to fit into a busy lifestyle. Bottom line: I’ll help you make fitness and nutrition a part of your life, without it taking over."
      },
      {
        icon: "img/icons/bulletTwo.svg",
        heading:
          "You want an expert to hold you accountable and keep you consistent through the program",
        body:
          "Nothing worth doing can be done alone. That’s why I work closely with my clients to help them eat well and exercise, no matter what other craziness is going on in their lives. You’re busy and have enough to worry about; let me take care of the fitness and nutrition details so you don’t have to."
      }
    ]
  }),
  methods: {
    goToWindow(link) {
      window.open(link, "_blank");
    },
    scrollTo(target) {
      var elmnt = document.getElementById(target);
      elmnt.scrollIntoView();
    },
    sendWhatsapp() {
      var message =
        "Name:%20" +
        this.name +
        "%0AContact:%20" +
        this.contact +
        "%0AMessage:%20" +
        this.message;
      message = message.split(" ").join("%20");
      window.open(
        "https://api.whatsapp.com/send?phone=+919419002682&" +
          "&text=%20" +
          message,
        "_blank"
      );
      this.name = "";
      this.contact = "";
      this.message = "";
    },
    nextClient() {
      this.client = this.client + 1 === this.client ? 0 : this.client + 1;
    },
    previousClient() {
      this.client = this.client - 1 < 0 ? this.clients - 1 : this.client - 1;
    }
  }
};
</script>

<style scoped>


.workSansLight{
  font-family: 'Work Sans', sans-serif !important;font-weight:400;font-style: normal;
}

.workSans{
  font-family: 'Work Sans', sans-serif !important;font-weight:700;font-style: normal;
}

.playFair{
  font-family: 'Playfair Display', serif !important;font-weight:700; font-style:italic;
}

.center {
  text-align: center;
}
.left {
  text-align: left;
}
.right {
  text-align: right;
}


  .pointer{
    cursor:pointer
  }

  body{
      overflow-x: hidden;
  }

</style>
